import React from "react";
import { Navigate, useLocation } from "react-router-dom";

// Dealer Email folded into the single Customer/Dealer Email page — this
// route now just redirects there with the dealer folder pre-selected,
// keeping old links (and the ?model= deep link) working.
const DealerEmailPage: React.FC = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  params.set("side", "dealer");
  return <Navigate to={`/customer-email?${params.toString()}`} replace />;
};

export default DealerEmailPage;
